<template>
  <v-container fluid fill-height>
    <!-- <span><v-btn
            color="#082FB1"
            variant="flat"
            prepend-icon="mdi-sync"
            class="rounded-lg"
            @click.stop.prevent="triggerFileInput"
            v-if="showCard=='product'"
            >
            Sync
          </v-btn></span> -->
          <span>
            <v-btn
              variant="flat"
              prepend-icon="mdi-sync"
              elevation="4"
              @click.stop.prevent="triggerFileInput"
              v-if="showCard == 'product'"
              style="background-color: #082FB1; color: white;"
            >
              Sync
            </v-btn>
          </span>
          <v-tooltip text="Upload a Excel" location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                class="upload-btn"
                elevation="4"
                @click.stop.prevent="triggerFileInput"
                color="#082FB1"
                variant="flat"
                prepend-icon="mdi-upload"
                v-if="showCard=='customer'"
                >
                    Upload
              </v-btn>
            </template>
          </v-tooltip>

    <v-row v-if="showCard=='organisation'">
      <v-col cols="12" sm="6" md="12">
          <BulkTemplateDownload :data="excelTemplate" text="bulkUpload"/>
      </v-col>
    </v-row>
    <v-row align="center" justify="center"  v-if="showCard=='organisation'">
      <v-col cols="12" sm="6" md="12" style="border: 3px dashed #ccc; border-radius: 10px; padding: 0px !important;">
        <v-card
          :class="['d-flex flex-column align-center justify-center text-center', { 'drag-active': dragActive }]"
          style="width: 100%; height: 600px; cursor: pointer;box-shadow: none !important;"
          outlined
          tile
          @click="triggerFileInput"
          @dragover.prevent="onDragOver"
          @dragenter.prevent="onDragEnter"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"
         
        >
          <v-icon size="48">mdi-cloud-upload-outline</v-icon>

          <div style="font-size: 14px; color: #4b5563; line-height: 1.1; margin-top: 8px;">
            <!-- <div>Drag & drop</div> -->
             <div style="font-size: 18px;font-weight: 500;">Choose a file or drag & drop it here</div>
             <div class="my-2">Support for Excel files up to 50MB</div>
            <div style="margin-top:4px">
              or <a href="#" @click.stop.prevent="triggerFileInput">Click to upload files here</a>
            </div>
            <div v-if="fileName" style="margin-top:8px; font-size:13px; color:#111;">
              {{ fileName }}
            </div>
          </div>
        </v-card>
        <!-- Hidden native input (inline style ensures it's really hidden) -->
       
      </v-col>
    </v-row>
     <input
          ref="fileInput"
          type="file"
          accept=".xlsx,.xls"
          style="display: none;"
          @change="handleFileSelect"
        />
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";
import clientDetailsService from "@/api/service/ClientDetails/ClientDetailsService";
import BulkTemplateDownload from "./BulkTemplateDownload.vue";

export default {
  name: "UploadCard",
  props:['showCard'],
  components:{
    BulkTemplateDownload
  },
  data() {
    return {
      dragActive: false,
      jsonData: [],
      fileName: "",
      excelTemplate:[
        {
          name: 'Organisations', 
          data:['organisation_name','organisation_name']
        },
        {
          name: 'Customers', 
          data:['customer','name','factor','edi','ucc_labels','asn','substitution','off_pack','customer_type','direct_customer','c855','c940997','courses_of_action']
        },
        {
          name: 'Shipping', 
          data:['customer','name','ship_type','shipping_instruction']
        },
        {
          name: 'Factories', 
          data:['supplier','supplier_type','name','edi','api','production_owner','courses_of_action']
        },
        {
          name: 'Exceptions', 
          data:['exception','title','author','revision','status','courses_of_action']
        }
      ]
    };
  },
  methods: {
    async getClient (){
        let res = await clientDetailsService.findAll({collectionName:'organisation'})
        this.clients = res.length > 0 ? res : []
        console.log(this.clients,"this.clients!!001")
    },
    triggerFileInput() {
      // open file picker
      this.$refs.fileInput.click();
    },
    onDragOver(e) {
      // required to allow drop
      e.dataTransfer.dropEffect = "copy";
    },
    onDragEnter() {
      this.dragActive = true;
    },
    onDragLeave() {
      // sometimes dragleave fires for child elements; we keep it simple
      this.dragActive = false;
    },
    onDrop(e) {
      this.dragActive = false;
      const files = e.dataTransfer && e.dataTransfer.files;
      if (!files || !files.length) return;
      const file = files[0];
      this.processFile(file);
    },
    handleFileSelect(e) {
      const file = e.target.files && e.target.files[0];
      if (file) {
        this.processFile(file);
        // clear input so same file can be re-selected later if needed
        e.target.value = "";
      }
    },
    processFile(file) {
      // Basic file type check (optional)
      const allowed = [".xlsx", ".xls"];
      const name = file.name || "";
      const ext = name.slice(name.lastIndexOf(".")).toLowerCase();
      if (!allowed.includes(ext)) {
        return this.$emit("error", "Only .xlsx/.xls files allowed");
      }

      this.fileName = name;

      const reader = new FileReader();
      reader.onload = (ev) => {
        try {
          const excelDatas = []
          const data = new Uint8Array(ev.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames;
          console.log(sheetName,"sheetName!!")
          const parsed = {};

          if(sheetName.length == 1){
            // alert('if')
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            this.jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
            console.log(this.jsonData,"this.jsonData!!!")
            this.$emit("uploaded", this.jsonData);

          } else if(sheetName.length > 0) {
            // alert('else')
            sheetName.forEach((sheetName) => {
              const sheet = workbook.Sheets[sheetName];
              parsed[sheetName] = XLSX.utils.sheet_to_json(sheet);
            });
            excelDatas.push(parsed)
            this.$emit("uploaded", excelDatas);
          }

          console.log("Excel JSON:",excelDatas);
        } catch (err) {
          console.error("Failed to parse Excel file", err);
          this.$emit("error", err);
        }
      };
      reader.readAsArrayBuffer(file);
    },

    // prevent browser from opening files dropped outside drop zone
    _preventWindowDrop(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  mounted() {
    // prevent default window drag/drop behaviour (opening file in browser)
    window.addEventListener("dragover", this._preventWindowDrop);
    window.addEventListener("drop", this._preventWindowDrop);
    this.getClient()
  },
  beforeUnmount() {
    window.removeEventListener("dragover", this._preventWindowDrop);
    window.removeEventListener("drop", this._preventWindowDrop);
  }
};
</script>

<style scoped>
.drag-active {
  border-color: #1976d2 !important; /* Vuetify primary */
  box-shadow: 0 6px 18px rgba(25, 118, 210, 0.12);
  transform: translateY(-1px);
}
a {
  color: #1976d2;
  text-decoration: none;
}
</style>
